var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 13.764V3h-2v10c.768 0 1.47.289 2 .764Zm0 4.472A2.989 2.989 0 0 1 11 19v2h2v-2.764ZM20 8V3h-2v2.17c1.165.413 2 1.524 2 2.83Zm-2 2.83A3.001 3.001 0 0 0 20 8v13h-2V10.83ZM6 6.17V3H4v3.17a2.994 2.994 0 0 1 2 0Zm0 5.66a2.994 2.994 0 0 1-2 0V21h2v-9.17Z",
  fill: "currentColor"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 9,
  r: 2,
  fill: "transapent",
  stroke: "currentColor",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 16,
  r: 2,
  fill: "transparent",
  stroke: "currentColor",
  strokeWidth: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 8,
  r: 2,
  fill: "transparent",
  stroke: "currentColor",
  strokeWidth: 2
})));
export default SvgFilter;